import logo from './logo.svg'
import newsImage from './banner.jpeg'

export const theme = {
    color: {
      primary: "#1b66b3",
      primaryHover: "#16508B",
    },
    logoImage: logo,
    backend: "https://edeka-campus.epaper-publishing-one.de/",
    directory: "/kiosk",
    header: {
      customer: "",
      title: "EDEKA Campus - Kiosk",
      bannerColor: "#fce531",
      fontColor: "#4A4A4A"
    },
    newsSlider: {
      image: newsImage
    },
    info: [
      {
        text: 'Impressum',
        link: 'https://verbund.edeka/karriere/karrierem%C3%B6glichkeiten/f%C3%BCr-mitarbeiter/datenschutz.html'
      },
      {
        text: 'Datenschutz',
        link: 'https://verbund.edeka/karriere/karrierem%C3%B6glichkeiten/f%C3%BCr-mitarbeiter/datenschutz.html'
      }
  ]
  };